export default {
  setProductId(state, payload) {
    state.productId = payload;
  },
  setAddress(state, payload) {
    state.address = payload;
  },
  setPersonalInformation(state, payload) {
    state.personalInformation = payload;
  },
  setBankAccount(state, payload) {
    state.bankAccount = payload;
  },
  setFundSelection(state, payload) {
    state.fundSelection = payload;
  },
  setFundAllocation(state, payload) {
    state.fundAllocation = payload;
  },
};
